import React, { useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import Tooltip from "../../../Common/Tooltip";
import { Controller, useForm } from "react-hook-form";
import { FORM_FIELDS } from "../../Constants";
import ErrorMessage from "../../components/ErrorMessage";
import {
  ictNumber,
  numbersOnly,
  phoneNumber,
  posTag,
} from "../../../../Config/Regex";
import NumberFormat from "react-number-format";

const AddPosModal = ({
  show,
  handleHide,
  addRecord,
  editRecord,
  updateData,
  posData,
}) => {
  const { STORE_DATA } = FORM_FIELDS;
  const { POS_DATA } = STORE_DATA;

  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    if (!updateData) return;
    Object.keys(updateData).forEach((x) => {
      setValue(x, updateData[x]);
    });
  }, [updateData]);

  const onSubmit = (data) => {
    if (updateData) {
      editRecord(updateData.id, data);
    } else {
      addRecord(data);
    }
    handleHide();
  };

  return (
    <Modal centered show={show} onHide={handleHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {updateData ? "Uredi blagajnu" : "Dodaj blagajnu"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label>{POS_DATA.TAG.title}</label>
          <Tooltip
            text={
              "Jedinstvena oznaka koja se dobije putem sustava e-porezna, dio je broja svakog izdanog računa. Ovaj podatak nalazi se u Internom aktu, nije ga dozvoljeno naknadno mijenjati, ako nije unesen fiskalizacija računa se neće izvršiti. Dopušten je unos do 5 znakova, kombinacija velikih i malih slova. Ako još nemate interni akt oznaku blagajne navedite kao i ovdje."
            }
          />
          <input
            type="text"
            className="form-control"
            name={POS_DATA.TAG.name}
            ref={register({
              required: true,
              pattern: posTag,
              validate: (data) => {
                if (data === updateData?.[POS_DATA.TAG.name]) {
                  return true;
                }

                let sameKey = false;
                posData.forEach((x) => {
                  if (x[POS_DATA.TAG.name] === data) {
                    sameKey = true;
                  }
                });
                return !sameKey;
              },
            })}
          />
          <ErrorMessage
            errorType={errors?.[STORE_DATA.TAG.name]?.type}
            messages={{
              required: "Ovo polje je obavezno.",
              validate: "Već postoji blagajna sa istom oznakom.",
              pattern: "Oznaka uređaja mora biti broj od 1 do 5 znamenki.",
            }}
          />
        </div>

        <div className="form-group">
          <label>{POS_DATA.DOCUMENT_NUMBER.title}</label>
          <Tooltip
            text={
              "Neprekinuti slijed broja računa koji je prema odredbama posebnih propisa o fiskalizaciji sastavni dio računa. Upišite broj od kojeg želite krenuti s izdavanjem računa. Npr. ukoliko krećete od 1, upišite 1. Ukoliko želite nastaviti slijed računa s prethodne blagajne, upišite prvi slijedeći broj po redoslijedu kojim ćete nastaviti neprekinuti slijed broja računa."
            }
          />
          <input
            type="number"
            className="form-control"
            name={POS_DATA.DOCUMENT_NUMBER.name}
            ref={register({
              required: true,
              min: 1,
              pattern: numbersOnly,
              max: 999999,
            })}
          />
          <ErrorMessage
            errorType={errors?.[POS_DATA.DOCUMENT_NUMBER.name]?.type}
            messages={{
              required: "Ovo polje je obavezno.",
              min: "Minimalna vrijednost je 1.",
              max: "Maksimalna vrijednost je 999999.",
              pattern: "Dozvoljen unos samo brojeva.",
            }}
          />
        </div>

        <div className="form-group">
          <label>{POS_DATA.DEPOSIT.title}</label>
          <Tooltip
            text={
              "Blagajnički polog sukladan podacima internog akta, nije propisan zakonom nego se određuje odlukom organizacije. Predstavlja minimalni iznos novca koji mora ostati u blagajni na kraju dana"
            }
          />
          <Controller
            name={POS_DATA.DEPOSIT.name}
            control={control}
            rules={{ maxLength: 9 }}
            as={
              <NumberFormat
                thousandSeparator={" "}
                decimalSeparator={","}
                fixedDecimalScale={true}
                decimalScale={2}
                placeholder={"0,00"}
                inputMode="numeric"
                className="form-control"
                allowNegative={false}
              />
            }
          />
          <ErrorMessage
            errorType={errors?.[POS_DATA.DEPOSIT.name]?.type}
            messages={{
              maxLength: "Maksimalna vrijednost je 99 999,99.",
            }}
          />
        </div>

        <hr></hr>
        <div className="form-group">
          <label>
            Ukoliko ste preuzeli blagajnu u T centru molimo popunite sljedeće
            podatke:
          </label>
        </div>

        <div className="form-group">
          <label>{POS_DATA.INVENTORY_NUMBER.title}</label>
          <Tooltip
            text={
              "Unos jedinstvenog identifikacijskog broja za potrebe praćenja inventure te prijave poteškoća službi za korisnike. Dodjeljuje se prilikom dolaska opreme na skladište te je povezan sa serijskim brojem uređaja."
            }
          />
          <input
            type="text"
            className="form-control"
            name={POS_DATA.INVENTORY_NUMBER.name}
            ref={register({
              required: false,
              pattern: ictNumber,
              maxLength: 25,
            })}
          />
          <ErrorMessage
            errorType={errors?.[POS_DATA.INVENTORY_NUMBER.name]?.type}
            messages={{
              required: "Ovo polje je obavezno.",
              maxLength: "Maksimalna duljina unosa je 25 znakova.",
              pattern: "Za unos su dopuštena samo slova i brojevi.",
            }}
          />
        </div>

        <div className="form-group">
          <label>{POS_DATA.MSISDN.title}</label>
          <Tooltip
            text={
              "MSISDN podatak će te pronaći na dokumentu preuzimanja blagajne u T-Centru"
            }
          />
          <input
            type="text"
            className="form-control"
            name={POS_DATA.MSISDN.name}
            ref={register({
              // required: true,
              maxLength: 50,
              pattern: phoneNumber,
            })}
          />
          <ErrorMessage
            errorType={errors?.[POS_DATA.MSISDN.name]?.type}
            messages={{
              required: "Ovo polje je obavezno!",
              maxLength: "Moguće je unijeti maksimalno 50 znakova.",
              pattern: `Dozvoljen je unos brojeva, "+" i "-".`,
            }}
          />
        </div>

        <div className="form-group">
          <label>{POS_DATA.POS_SERIAL_NUMBER.title}</label>
          <Tooltip
            text={
              "Polje za unos serijskog broja blagajne kojeg možete pronaći na samom uređaju (blagajni)."
            }
          />
          <input
            type="text"
            className="form-control"
            name={POS_DATA.POS_SERIAL_NUMBER.name}
            ref={register({
              // required: true,
              pattern: numbersOnly,
              maxLength: 50,
            })}
          />
          <ErrorMessage
            errorType={errors?.[POS_DATA.POS_SERIAL_NUMBER.name]?.type}
            messages={{
              required: "Ovo polje je obavezno!",
              maxLength: "Moguće je unijeti maksimalno 50 znakova.",
              pattern: `Dozvoljen je samo unos brojeva.`,
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          data-dismiss="modal"
          onClick={handleHide}
        >
          Zatvori
        </button>
        <Button onClick={handleSubmit(onSubmit)}>
          {updateData ? "Uredi" : "Dodaj"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddPosModal;
